import { Alert } from 'antd';
import type { AnalyticsResponse } from '@mygate/common';
import { AssetAllocation, PortfolioDepth } from '../InvestorAnalyticsCharts';
import { AnalyticsMetric, AnalyticsPanel, euro, integer } from './AnalyticsPrimitives';
import { AnalyticsCoverage } from './AnalyticsCoverage';

export function AnalyticsInvestments({ data }: { data: AnalyticsResponse }) {
  const investment = data.investments;
  if (!investment) {
    return (
      <>
        <Alert type="info" showIcon message={data.unavailableReason} />
        <AnalyticsCoverage data={data} />
      </>
    );
  }
  return (
    <>
      <div className="analytics-metrics analytics-metrics--three">
        <AnalyticsMetric
          title="Anlagevolumen"
          value={euro.format(investment.totalValueEur)}
          note="Erfasster Teilbestand · ohne Cash"
          definition="Summe bestätigter Marktwerte. Fehlende Bestände und Preise sind nicht enthalten; kein vollständiges Plattform-AUM."
        />
        <AnalyticsMetric
          title="Cash"
          value={euro.format(investment.cashValueEur)}
          note="Tradevest-Verrechnungskonten"
          definition="Erfasstes Guthaben zum Stichtag. Der Saldo sagt nichts über historische Einzahlungen aus."
        />
        <AnalyticsMetric
          title="Nutzer mit Anlagebestand"
          value={integer.format(investment.investedUsers)}
          note={`Von ${data.coverage.freshUsers} erfassten Accounts`}
          definition="Mindestens eine bekannte positive Anlageposition. Fehlende Positionslisten können weitere Anleger verbergen."
        />
      </div>
      <div className="analytics-grid">
        <AnalyticsPanel title="Assetklassen">
          <AssetAllocation data={investment} />
        </AnalyticsPanel>
        <AnalyticsPanel title="Portfolio je Anleger">
          <PortfolioDepth data={investment} />
        </AnalyticsPanel>
      </div>
      <AnalyticsCoverage data={data} />
    </>
  );
}
